module.exports = __webpack_public_path__ + "static/img/money.43ba21d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/commonPage/img/money.png
// module id = 9LgI
// module chunks = 1